import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bool } from "prop-types";
import { Link } from "react-router-dom";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Drawer from "pages/_components/Drawer/Drawer";
import { actions as debinActions } from "reducers/debin";
import { debinOptions } from "util/debin";
import { getLimitDate } from "util/date";
import { actions as accountsActions } from "reducers/accounts";

import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import TitleColumns from "./components/TitleColumns";
import RecurrentDebinItem from "./components/ItemRow";
import EmitedSideBarForm from "../_components/SideBarForm";
import FilterTags from "../_components/FilterTags";

const RecurrentDebin = ({ isDesktop }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { fetching, totalPages, pageNumber, filterRecurrencyList, debinRecurrency } = useSelector(
        (state) => state.debin,
    );
    const dispatch = useDispatch();
    const [debinPagination, setDebinPagination] = useState(pageNumber);
    const hasMoreData = pageNumber < totalPages;
    const row = isDesktop ? 1 : 3;

    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const fetchMoreTransactions = () => {
        setDebinPagination(pageNumber + 1);
        dispatch(debinActions.loadIncomingRequests({ ...filterRecurrencyList, pageNumber: debinPagination + 1 }));
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };
    useEffect(() => {
        dispatch(
            debinActions.getDebinRecurrencies({
                cbu: "",
                account: "",
                pageNumber: 1,
                seller: "",
                status: "TODOS",
                createdFrom: getLimitDate(-92),
                createdTo: getLimitDate(7),
            }),
        );
    }, []);
    return (
        <div className="container">
            <FilterTags openSideBarFilters={openSideBarFilters} optiondebin={debinOptions[1]} isRecurrent />
            {debinRecurrency?.length ? (
                <>
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetching}
                        items={debinRecurrency || []}
                        noDataText="debin.global.no.results"
                        noFiltersDataText="debin.global.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                rows={row}
                                key={`emited-debin-item-${item.id}`}
                                renderAs={Link}
                                to={`/debin/recurent/detail/${item.id}`}>
                                <RecurrentDebinItem
                                    key={`transaction-${item.id}`}
                                    emitededDebin={item}
                                    setDrawer={setActionDrawer}
                                    isDesktop={isDesktop}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="debin-table">
                                <GridTable.Header>
                                    <GridTable.Container rows={row}>
                                        <TitleColumns />
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>
                                    {listItem}
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                        />
                                    )}
                                </GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                </>
            ) : (
                <EmptyScreenAlert message="debin.service.empty.recurrent" />
            )}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <EmitedSideBarForm closeSidebar={setOpenSidebar} isRecurrent />
            </Drawer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

RecurrentDebin.propTypes = {
    isDesktop: bool.isRequired,
};

export default RecurrentDebin;
